export const REGISTER_REQUEST = 'REGISTER_REQUEST';

export const registerRequest = ( userData ) => ({
    type: REGISTER_REQUEST,
    payload: { ...userData },
});
